export default __webpack_public_path__ + "img/70263c140e4b08304a7b81e34a513195.png";